function SocialMedia(props) {
  return (
    <ul className="socialmedia-list ">
      <li>
        <a
          href="https://github.com/CeciPeriquet"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa-brands fa-github-alt"></i>
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/in/ceciliaperiquet/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa-brands fa-linkedin"></i>
        </a>
      </li>
    </ul>
  );
}

export default SocialMedia;
